<template>
	<el-dialog
    :visible.sync="choosePosVisibility"
    :modal-append-to-body="false"
    :show-close='false'
    class="editCardDio pin_dio"
    :close-on-click-modal='false'
    width="840px"
    center
    >
        <template slot="title">
            <h1 class="posDio_tit">{{dioTit}}</h1>
            <div class="posDio_titTips">
                Some brands support the use of Doshii. Once the Doshii account is linked,
                Peiso will automatically obtain income data from Doshii every day.
            </div>
        </template>
        <div class="body_posdio">
            <scroll>
                <ul class="posList-ul">
                    <li 
                    class="posItem-li"
                    v-for="(item,i) in posList"
                    :key="i"
                    @click="choosePos(item)">
                        {{item.posBrand}}
                        <span class="pos_canUseBox">{{item.posIsSupport==1?'Doshii Available':''}}</span>
                        <i class="pos_checkBox" :class="{'pos_checked':checked == item.posId}"></i>
                    </li>
                    <li v-if="!posList.length" class="posItem-li noData">No Data</li>
                </ul>
            </scroll>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
            <el-button @click="confirm" class="cardConBtn">{{'Save'}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import scroll from './scroll.vue';
import api from '../../api/api'
export default {
    props:['choosePosVisibility','posId'],
    components:{scroll},
    data () {
        return {
            checked:1,
            dioTit:'Please select the POS brand you are using',
            posList:[]
        }
    },
    methods: {
        getPosList(){
            api.getPosListInfo('',res=>{
                if(res.data.code==0){
					this.posList = res.data.data
				} else{
					Utils.alert('', res.data.message, 'error')
				}
            })
        },
        cancel(){
            this.checked = ''
            this.$emit('closeDiolog')
        },
        choosePos(val){
            this.checked = val.posId
        },
        confirm(){
            api.updataPos({posId:this.checked},res=>{
                let {code , message ,data} = res.data
                if(code==0){       
                    this.$emit('confirmPos',this.checked)  
                    this.checked = ''
                }else{
                    Utils.alert('',message,'error')
                }
            })
        }
    },
    mounted() {
        console.log(this.posId);
        this.checked = this.posId
        this.getPosList()
    },
}
</script>

<style lang="scss" scoped>
/deep/ {
    .posDio_tit{
        font-size: 24px;
        font-weight: 600;
        color: var(--text-color);
        line-height: 33px;
    }
    .posDio_titTips{
        width: 100%;
        font-size: 20px;
        font-weight: 400;
        color: var(--text-color);
        line-height: 28px;
        margin-top: 10px;
    }
    .body_posdio{
        .posList-ul{
            max-height: 300px;
            .posItem-li{
                cursor: pointer;
                display: flex;
                align-items: center;
                padding: 0 20px;
                width: 100%;
                height: 50px;
                background: var(--background-color-3);
                font-size: 20px;
                font-weight: 400;
                color: var(--text-color);
                border-top: 1px solid #5F5F5F;
                .pos_canUseBox{
                    font-size: 16px;
                    font-weight: 400;
                    color: #2CCA73;
                    margin: 0 50px 0 auto;
                }
                .pos_checkBox{
                    width:16px;
                    min-width:16px;
                    height:16px;
                }
                .pos_checked{
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    cursor: pointer;
                }
            }
            .noData{
                justify-content: center;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/choosePosDio.vue